import MillOrderJobForm from '@/models/jobs/mill-orders/MillOrderJobForm'
import type { TMillOrdersState } from '@/types/state-types'

export default <TMillOrdersState>{
  millOrderForm: new MillOrderJobForm(),
  isMillOrderLoading: false
}
